<template>
  <div class="black--background mt-10">
    <v-container class="full-screen-app-bar-footer">
      <v-row class="mb-3">
        <v-col cols="12" sm="6" md="4" lg="3"
               style="position: relative"
               :class="{'pr-8': $vuetify.breakpoint.mdAndUp}">
          <FooterMainMenuCard
            :items="menus"
            @onClick="menuRouteHandler"
            @onClickSubMenu="menuRouteHandler"
          ></FooterMainMenuCard>
          <div style="position: absolute;"
               class="hidden-sm-and-down newsletter-social"
          >
            <GreenButton
                    width="200px"
                    class="newsletter-label-max-width mb-5"
                    label="E-newsletter"
                    @onPress="gotoEnewsletter"
            />
            <v-layout px-1>
              <v-flex shrink mr-5 v-for="(item, i) in social" :key="i">
                <v-img
                        contain
                        width="33px"
                        height="33px"
                        style="border-radius: 100%;"
                        class="cursor-pointer"
                        :src="item.icon"
                        @click="socialClick(item)"
                ></v-img>
              </v-flex>
            </v-layout>
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="8" lg="9" :class="{'pl-8': $vuetify.breakpoint.mdAndUp}">
          <v-row :class="{'card-minus-margin': $vuetify.breakpoint.mdAndUp}">
            <template v-for="(item, index) of menuList">
              <v-col
                cols="12"
                sm="12"
                md="6"
                lg="4"
                v-if="item.menuNameList.length > 0"
                :key="index"
                :class="{'pr-8': $vuetify.breakpoint.mdAndUp}"
              >
                <FooterMenuCard
                  :title="item[`title_${lang}`]"
                  :items="item.menuNameList"
                  @onClickHeader="menuHeaderHandler"
                  @onClick="menuRouteHandler"
                  @onClickSubMenu="menuRouteHandler"
                ></FooterMenuCard>
              </v-col>
            </template>
          </v-row>
        </v-col>
        <v-col cols="12" class="hidden-md-and-up pt-0">
          <GreenButton
                width="200px"
                class="newsletter-label-max-width mb-5"
                label="E-newsletter"
                @onPress="gotoEnewsletter"
          />
          <v-layout px-1>
            <v-flex shrink mr-5 v-for="(item, i) in social" :key="i">
              <v-img
                      contain
                      width="33px"
                      height="33px"
                      style="border-radius: 100%;"
                      class="cursor-pointer"
                      :src="item.icon"
                      @click="socialClick(item)"
              ></v-img>
            </v-flex>
          </v-layout>
          </v-col>
      </v-row>
      <v-row class="px-3 pb-3">
        <v-layout justify-start>
          <v-flex shrink v-for="(item, i) in ref_logo" :key="i">
            <v-img
                    width="75px"
                    contain
                    class="cursor-pointer mr-5"
                    :src="item.icon"
                    @click="routeTo(item.name)"
            ></v-img>
          </v-flex>
        </v-layout>
      </v-row>
      <v-row class="my-0 pa-3">
        <v-layout justify-start class="white--text" style="font-size: 12px">
          Copyright © 2017 TCDC (Thailand Creative & Design Center). All rights reserved.
        </v-layout>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import FooterMenuCard from "./FooterMenuCard";
import FooterMainMenuCard from "./FooterMainMenuCard";
import GreenButton from "../buttons/GreenButton";
import { mapState } from 'vuex';

export default {
  methods: {
    gotoEnewsletter() {
      if (this.$route.path !== '/enewsletter') {
        this.$router.push('/enewsletter');
      } else {
        this.$vuetify.goTo('#enewsletter');
      }
    },
    routeTo(web) {
      switch (web) {
        case 'cea':
          window.open('https://data.cea.or.th/');
          break;
        case 'gov':
          window.open('http://www.opm.go.th/opmportal/default.asp');
          break;
        case 'tcdc':
          window.open('http://web.tcdc.or.th/');
          break;
      }
    },
    menuHeaderHandler() {
      this.$router.push("/home");
    },
    menuRouteHandler(item) {
      const path = item.path;
      const website = item.website;
      if (website) {
        window.open(website);
      }
      if (path) {
        this.visible = false;
        if (this.$route.path != path) {

          if (this.$route.path == '/service/resource-center/e-book') {
            this.$store.dispatch('Article/onGetAllEbooks', { page: 1, lang: this.lang }).then(() => {
              this.$router.push(path);
            });

          } else if (this.$route.path == '/service/resource-center/article') {
            this.$store.dispatch('Article/onGetAllArticles', { page: 1, lang: this.lang }).then(() => {
              this.$router.push(path);
            });

          } else if (this.$route.path == '/service/resource-center/online-exhibition') {
            this.$store.dispatch('Article/onGetAllOnlineExhibitions', { branch: this.branchId, page: 1, lang: this.lang }).then(() => {
              this.$router.push(path);
            });

          } else if (this.$route.path == '/service/resource-center/design-world-calendar') {
            this.$store.dispatch('Program/onGetDesignWorldCalendar', { lang: this.lang }).then(() => {
              this.$router.push(path);
            });

          } else if (this.$route.path == '/faqs') {
            this.$store.dispatch('Faq/onGetAllFaqs', this.lang).then(() => {
              this.$router.push(path);
            });

          } else {
            this.$router.push(path);
          }

        }
        return;
      }
    },
    socialClick(social) {
      switch (social.name) {
        case 'youtube':
        case 'facebook':
        case 'line':
        case 'twitter':
          window.open(social.link);
          break;
      }
    }
  },
  data: () => ({
    menus: [
      {
        name: "about",
        path: "/about-main"
      },
      {
        name: "resource center",
        subMenuList: [
          { name: "article", path: "/service/resource-center/article" },
          { name: "e-book", path: "/service/resource-center/e-book" },
          {
            name: "online exhibition",
            path: "/service/resource-center/online-exhibition"
          },
          {
            name: "design world calendar",
            path: "/service/resource-center/design-world-calendar"
          }
        ]
        // path: "/service/resource-center"
      },
      {
        name: "my tcdc",
        website: "https://my.tcdc.or.th/"
      },
      // {
      //   name: "network"
      // },
      {
        name: "career",
        website: "https://www.cea.or.th/th/career"
      },
      {
        name: "FAQS",
        path: "/faqs"
      }
    ],
    social: [
      {
        icon: require('../../assets/icons/social/youtube.png'),
        name: 'youtube',
        link: 'https://www.youtube.com/user/TCDCThailand'
      },
      {
        icon: require('../../assets/icons/social/facebook.png'),
        name: 'facebook',
        link: 'https://www.facebook.com/tcdc.thailand'
      },
      {
        icon: require('../../assets/icons/social/twitter.png'),
        name: 'twitter',
        link: 'https://twitter.com/tcdc'
      },
      {
        icon: require('../../assets/icons/social/line.png'),
        name: 'line',
        link: 'https://line.me/ti/p/~@TCDC'
      }
    ],
    ref_logo: [
      {
        icon: require('../../assets/icons/logo-opm.png'),
        name: 'gov'
      },
      {
        icon: require('../../assets/icons/logo-cea.png'),
        name: 'cea'
      },
      {
        icon: require('../../assets/icons/tcdc-logo.png'),
        name: 'tcdc'
      }
    ]
  }),
  components: {
    FooterMainMenuCard,
    FooterMenuCard,
    GreenButton
  },
  computed: {
    ...mapState({
      menuList: state => {
        return [
          ...state.Branch.branches.map(branch => ({
            title_th: branch.branch_name_th,
            title_en: branch.branch_name_en,
            menuNameList: [
              ...branch.menu.map(menu=>({
                name_th: menu.title_th,
                name_en: menu.title_en,
                path: menu.path,
                subMenuList: [
                  ...menu.sub_menu.map(subMenu=>({
                    name_th: subMenu.title_th,
                    name_en: subMenu.title_en,
                    path: subMenu.path,
                  }))
                ]
              }))
            ],
          }))
        ];
      },
      lang: state => state.Branch.lang,
      branchId: state => state.Branch.branch_id
    })
  }
};
</script>

<style lang="scss" scoped>
.full-screen-app-bar-footer {
  width: 100vw;
}
.footer-tcdc-logo {
  height: 60px;
  object-fit: contain;
}
.newsletter-label-max-width {
  max-width: 250px;
}
.tcdc-footer-border-green {
  border-bottom: 2px solid white;
}
.card-minus-margin {
  margin-right: -28px;
}
</style>
